import { m } from 'framer-motion'
import type { ComponentProps } from 'react'

export function CheckIcon(props: ComponentProps<'svg'>) {
	return (
		<div className="border-medium text-medium lg:text-large flex size-8 shrink-0 items-center justify-center rounded-full font-semibold lg:size-9">
			<svg {...props} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
				<m.path
					animate={{ pathLength: 1 }}
					d="M5 13l4 4L19 7"
					initial={{ pathLength: 0 }}
					strokeLinecap="round"
					strokeLinejoin="round"
					transition={{
						delay: 0.2,
						type: 'tween',
						ease: 'easeOut',
						duration: 0.3,
					}}
				/>
			</svg>
		</div>
	)
}
